import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../shared/HubLayout.css';
import { useMobileSubNav } from '../layout/MobileNavContext';
import { useHubScreen } from '../layout/useHubScreen';
import BackToLotLink from '../shared/lots/BackToLotLink';
import Lots, { LotsActions } from './lots/Lots';
import ReproductionV2, { ReproductionV2Actions } from './active/ReproductionV2';
import Bulls, { BullsActions } from './bulls/Bulls';
import DefaultProtocolSettings from './DefaultProtocolSettings';
import DefaultBullSettings from './DefaultBullSettings';
import Protocols, { ProtocolsActions } from './protocols/Protocols';
import SectionDescription from '../shared/SectionDescription';

const SUB_PATHS = ['animals', 'lots', 'bulls', 'protocols', 'settings'];

const SECTION_INFO = [
  { titleKey: 'repro_active_section_title', textKey: 'repro_active_section_text' },
  { titleKey: 'repro_lots_section_title',   textKey: 'repro_lots_section_text' },
  { titleKey: 'repro_bulls_section_title',  textKey: 'repro_bulls_section_text' },
  { titleKey: 'repro_protocols_section_title', textKey: 'repro_protocols_section_text' },
  { titleKey: 'repro_settings_section_title', textKey: 'repro_settings_section_text' },
];

export const ReproductionHub = () => {
  const { t } = useTranslation();
  const { subTab, screen, setScreen, recordId } = useHubScreen();
  const navigate = useNavigate();
  const location = useLocation();
  const { setSubNav } = useMobileSubNav();

  const activeSubTab = Math.max(0, SUB_PATHS.indexOf(subTab));

  const [lotFilter] = useState(location.state?.lotFilter || null);

  const subTabs = [
    t("animals"),
    t("lots"),
    t("bulls"),
    t("protocols"),
    t("settings"),
  ];

  const handleSubTabClick = (index) => {
    navigate(`/reproduction/${SUB_PATHS[index]}`);
  };

  useEffect(() => {
    setSubNav({ tabs: subTabs, activeTab: activeSubTab, onTabClicked: handleSubTabClick });
    return () => setSubNav(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSubTab, setSubNav]);

  return (
    <div className="hub">
      <div className="hub-content">
        {activeSubTab === 0 && (
          <BackToLotLink lotId={lotFilter} prefix={t('lot_prefix')} basePath="/reproduction/lots" />
        )}
        <SectionDescription
          title={t(SECTION_INFO[activeSubTab].titleKey)}
          text={t(SECTION_INFO[activeSubTab].textKey)}
        />
        {activeSubTab === 0 && (
          <ReproductionV2
            initialLotFilter={lotFilter}
            screen={screen}
            setScreen={setScreen}
            actions={<ReproductionV2Actions screen={screen} setScreen={setScreen} />}
          />
        )}
        {activeSubTab === 1 && (
          <Lots
            screen={screen}
            setScreen={setScreen}
            actions={<LotsActions screen={screen} setScreen={setScreen} />}
          />
        )}
        {activeSubTab === 2 && (
          <Bulls
            screen={screen}
            setScreen={setScreen}
            actions={<BullsActions screen={screen} setScreen={setScreen} />}
          />
        )}
        {activeSubTab === 3 && (
          <Protocols
            planType="iatf"
            recordId={recordId}
            screen={screen}
            setScreen={setScreen}
            actions={<ProtocolsActions screen={screen} setScreen={setScreen} />}
          />
        )}
        {activeSubTab === 4 && (
          <div>
            <DefaultProtocolSettings />
            <DefaultBullSettings />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReproductionHub;
